import React from "react";
import { OWLBERT_MAIN, OWLBERT_ACCENT, OWLBERT_BLACK, OWLBERT_WHITE } from "@/lib/owlbert";

/**
 * <Owlbert /> — the mascot's face. Picks a variant per context:
 *   - mood="cheer"   → main (indigo on light)   — Portal, empty states, hero
 *   - mood="focus"   → black (transparent black) — Operator dark accents
 *   - mood="alert"   → accent (light on indigo)  — Promo, banners
 *   - mood="whisper" → white (transparent white) — Dark banners, footers
 * Sizes: xs (16), sm (24), md (36), lg (56), xl (96), hero (128)
 */
const SIZE = { xs: 16, sm: 24, md: 36, lg: 56, xl: 96, hero: 128 };
const VARIANT = {
  cheer: OWLBERT_MAIN,
  focus: OWLBERT_BLACK,
  alert: OWLBERT_ACCENT,
  whisper: OWLBERT_WHITE,
};

export default function Owlbert({
  mood = "cheer",
  size = "md",
  className = "",
  float = false,
  "data-testid": testId,
  ...rest
}) {
  const px = SIZE[size] || SIZE.md;
  const src = VARIANT[mood] || VARIANT.cheer;
  return (
    <img
      src={src}
      alt="Owlbert"
      width={px}
      height={px}
      className={`inline-block object-contain ${className}`}
      style={{
        filter: float ? "drop-shadow(0 6px 18px rgba(17,24,39,0.14))" : "none",
        background: "transparent",
      }}
      data-testid={testId || `owlbert-${mood}`}
      {...rest}
    />
  );
}
